import { render, staticRenderFns } from "./AyudaParte1Acopio.vue?vue&type=template&id=5f652288&scoped=true"
import script from "./AyudaParte1Acopio.vue?vue&type=script&lang=js"
export * from "./AyudaParte1Acopio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f652288",
  null
  
)

export default component.exports